import React from 'react';
import { typography } from './tokens';

export default function SectionHeader({ title, subtitle, actions, className = '', style = {} }) {
  return (
    <div className={`flex items-center justify-between ${className}`} style={style}>
      <div>
        <div style={{ fontSize: typography.h1.fontSize, fontWeight: typography.h1.fontWeight, lineHeight: typography.h1.lineHeight }}>{title}</div>
        {subtitle && (
          <div style={{ fontSize: typography.meta.fontSize, lineHeight: typography.meta.lineHeight }} className="text-gray-600 dark:text-gray-400 mt-0.5">{subtitle}</div>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2">{actions}</div>
      )}
    </div>
  );
}
